'use client'

import { IBitComment } from 'types/src/types';
import { Comments } from './Comments';
import { Badge } from '@workspace/ui/components/badge';
import { CreateComment } from './CreateComment';

type Props = {
  bitId: number;
  comments: IBitComment[];
  commentsCount?: number;
  onCommentPosted: () => void;
  isAnonymous?: boolean;
  children?: React.ReactNode;
};

export const CommentsSection = ({ bitId, comments, commentsCount, onCommentPosted, isAnonymous, children }: Props) => {
  return (
    <div className="md:w-[745px] w-full mt-5 relative">
      {children}
      <h3 className="text-lg md:text-2xl font-semibold mb-4 flex items-center gap-2">
        Comments
        <Badge variant="outline" className="text-black bg-bg-gray rounded-xl">
          {commentsCount}
        </Badge>
      </h3>
      {!isAnonymous && (
        <CreateComment bitId={bitId} onCommentPosted={onCommentPosted} />
      )}
      <Comments comments={comments} onCommentPosted={onCommentPosted} />
    </div>
  );
};
